import React from 'react';
import { CloseIcon } from 'app/icons';
import cn from 'classnames'
import styles from '../../styles.module.scss'
import PropTypes from 'prop-types';

const VendorProgramModal = ({ children, onClose }) => {
  return (
    <div className="modal_wrapper">
      <table className="modal_bg">
        <tbody>
        <tr>
          <td className="modal_wp">
            <div className="modal_ct">
              <div className={cn('modal', styles.vendorPointModal)}>
                <div className="title flex justify-between">
                  <div onClick={onClose} className="cursor-pointer">
                    <CloseIcon width={30} height={30} />
                  </div>
                </div>
                <div className={cn('modal_body', styles.vendorPointModalBody)}>
                  {children}
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  )
}

VendorProgramModal.propTypes = {
  children: PropTypes.node.isRequired
};

export default VendorProgramModal;
